import { API_ROUTES } from "../constants/apiRoutes";
import {
  CheckKycResponse,
  CreateKycDto,
  CreateKycResponse,
  OcrApiResponse,
  OcrPassportData,
} from "../types/kyc";
import { axiosClient, digitalIdClient } from "./axios";

export interface KycUploadImageResponseDto {
  message: string;
  file_url: string;
}

export const postKyc = async (
  data: CreateKycDto,
): Promise<CreateKycResponse> => {
  const res = await axiosClient.post<CreateKycResponse>(
    API_ROUTES.CREATE_KYC,
    data,
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
  return res.data;
};

export const postImage = async (image: File): Promise<string> => {
  const formData = new FormData();
  formData.append("file", image);
  const res = await digitalIdClient.post<KycUploadImageResponseDto>(
    API_ROUTES.UPLOAD_IMAGE,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );

  return res.data.file_url;
};

export const postOcrPassport = async (image: File): Promise<OcrApiResponse> => {
  const formData = new FormData();
  formData.append("document_image", image);

  const res = await axiosClient.post<string>(
    API_ROUTES.OCR_PASSPORT_URL,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      responseType: "text",
      transformResponse: [(data) => data],
    },
  );

  const rawResponse = (res.data ?? "").trim();
  if (!rawResponse) {
    throw new Error("OCR service returned an empty response.");
  }

  if (rawResponse.startsWith("<")) {
    throw new Error(
      "OCR service returned HTML instead of JSON. Check the UAT base URL and OCR endpoint.",
    );
  }

  let parsedResponse: unknown;
  try {
    parsedResponse = JSON.parse(rawResponse);
  } catch {
    throw new Error("OCR service returned invalid JSON.");
  }

  if (
    parsedResponse &&
    typeof parsedResponse === "object" &&
    "data" in parsedResponse
  ) {
    return parsedResponse as OcrApiResponse;
  }

  return {
    code: "200",
    message: "OK",
    data: parsedResponse as OcrPassportData,
  };
};

export const postCheckKyc = async (
  cusId: string,
): Promise<CheckKycResponse> => {
  const res = await axiosClient.post<CheckKycResponse>(
    API_ROUTES.CHECK_KYC,
    { cus_id: cusId },
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
  return res.data;
};
